import { render } from "./QuizQuestions.vue?vue&type=template&id=27548ff0"
import script from "./QuizQuestions.vue?vue&type=script&lang=js"
export * from "./QuizQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__